<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 28">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h32v32H0z"/>
      <path class="content" :stroke="fill" stroke-width="3" d="M11 14l5 5 5-5"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#383C61'
    }
  }
}
</script>
